import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=8c384026&scoped=true&"
import script from "./Pdf.vue?vue&type=script&lang=ts&"
export * from "./Pdf.vue?vue&type=script&lang=ts&"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=8c384026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c384026",
  null
  
)

export default component.exports